<template>
  <v-dialog
    :value="value"
    :max-width="maxWidth"
    :persistent="persistent"
    :scrollable="scrollable"
    content-class="br-app-modal"
    transition="dialog-bottom-transition"
    @input="$emit('input', $event)"
  >
    <v-card class="br-app-modal__card">
      <v-card-title v-if="title || $slots.title" class="br-app-modal__title">
        <slot name="title">
          <v-icon v-if="icon" color="white" size="22" class="mr-2">{{ icon }}</v-icon>
          {{ title }}
        </slot>
        <v-btn
          v-if="showClose"
          icon
          dark
          small
          class="br-app-modal__close"
          aria-label="Fechar"
          @click="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-subtitle v-if="subtitle" class="br-app-modal__subtitle">
        {{ subtitle }}
      </v-card-subtitle>

      <v-card-text :class="['br-app-modal__body', { 'br-app-modal__body--flush': flushBody }]">
        <slot />
      </v-card-text>

      <v-card-actions v-if="$slots.actions" class="br-app-modal__actions">
        <slot name="actions" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "AppModal",

  props: {
    value: { type: Boolean, required: true },
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
    icon: { type: String, default: "" },
    maxWidth: { type: [Number, String], default: 560 },
    persistent: { type: Boolean, default: false },
    scrollable: { type: Boolean, default: false },
    showClose: { type: Boolean, default: false },
    flushBody: { type: Boolean, default: false },
  },

  methods: {
    close() {
      this.$emit("input", false);
    },
  },
});
</script>

<style scoped lang="scss">
@import "@/assets/scss/design-system/tokens";

.br-app-modal__card {
  border-radius: $br-radius-lg !important;
  overflow: hidden;
}

.br-app-modal__title {
  background: linear-gradient(120deg, $br-brand 0%, $br-brand-darker 100%);
  color: #fff !important;
  font-size: 1.05rem !important;
  font-weight: 700 !important;
  padding: $br-space-4 $br-space-5 !important;
  position: relative;
}

.br-app-modal__close {
  position: absolute !important;
  right: $br-space-2;
  top: 50%;
  transform: translateY(-50%);
}

.br-app-modal__subtitle {
  padding: $br-space-3 $br-space-5 0 !important;
  color: $br-muted !important;
  font-size: $br-font-size-sm !important;
  font-weight: 500;
}

.br-app-modal__body {
  padding: $br-space-5 !important;
  color: $br-ink-soft;
}

.br-app-modal__body--flush {
  padding: 0 !important;
}

.br-app-modal__actions {
  padding: $br-space-2 $br-space-4 $br-space-4 !important;
  gap: $br-space-2;
  justify-content: flex-end;
  border-top: 1px solid $br-border-soft;
}
</style>
